import { Spinner } from '@/components/Spinner';
import { useGetSubDomainDetail } from '../hooks/useGetSubDomainDetail';
import ManageClubSubdomainForm from './ManageClubSubdomainForm';

const ManageClubSubdomainFormContainer = ({ clubId }: { clubId: string }) => {
  const { data, isLoading } = useGetSubDomainDetail(clubId);

  const defaultValues = { subDomainName: data?.subDomainName || '', description: data?.description || '' };

  if (isLoading) return <Spinner />;
  return <ManageClubSubdomainForm defaultValues={defaultValues} clubId={clubId} />;
};

export default ManageClubSubdomainFormContainer;
